<script lang="ts">
  const { size = '1em' }: { size?: string | number } = $props();
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 48 47"
  fill="#FFBF00"
  xmlns="http://www.w3.org/2000/svg"
>
  <g>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.279 27.7094L12.0174 44.7367C11.9163 45.498 12.26 46.2499 12.9019 46.6716C13.5438 47.0933 14.3704 47.1101 15.029 46.715L24 41.3324L32.971 46.715C33.6295 47.1101 34.4561 47.0933 35.098 46.6717C35.7398 46.2501 36.0836 45.4982 35.9826 44.737L33.7233 27.7077C31.0283 29.7728 27.6575 31 24 31C20.3435 31 16.9735 29.7735 14.279 27.7094Z"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M38 15C38 22.732 31.732 29 24 29C16.268 29 10 22.732 10 15C10 7.26801 16.268 1 24 1C31.732 1 38 7.26801 38 15ZM19.6037 22.8706L23.4991 20.7305C23.8126 20.5582 24.1872 20.5582 24.5008 20.7305L28.3961 22.8706C28.6056 22.9857 28.8456 23.0254 29.0789 22.9836C29.6648 22.8786 30.0583 22.2971 29.9578 21.6848L29.2139 17.1521C29.154 16.7872 29.2698 16.4149 29.5234 16.1565L32.6748 12.9464C32.8443 12.7738 32.9546 12.5475 32.9887 12.3027C33.0742 11.688 32.6666 11.1172 32.0783 11.0279L27.7232 10.3666C27.3726 10.3133 27.0696 10.0832 26.9128 9.75126L24.9651 5.62725C24.8604 5.40542 24.6885 5.22588 24.4763 5.1164C23.9432 4.84148 23.2978 5.07019 23.0347 5.62725L21.0871 9.75126C20.9303 10.0832 20.6272 10.3133 20.2767 10.3666L15.9216 11.0279C15.6873 11.0635 15.4708 11.1787 15.3056 11.3559C14.8907 11.8007 14.8994 12.5128 15.325 12.9464L18.4764 16.1565C18.7301 16.4149 18.8459 16.7872 18.786 17.1521L18.042 21.6848C18.002 21.9287 18.04 22.1794 18.1502 22.3984C18.4268 22.9482 19.0776 23.1596 19.6037 22.8706Z"
    />
  </g>
</svg>

<style lang="scss">
  @use 'sass:color';
  @use '~/theme/theme';
  svg {
    fill: theme.$star;
    stroke: color.adjust(theme.$star, $lightness: -20%);
    :global(html.dark-mode) & {
      stroke: none;
    }
  }
</style>
